<template>
  <v-col cols="12" v-if="permisoVista('usomaquinas','r')">
    <div class="text-center text-h3">
        MTTR Y MTBF del Día Anterior ({{ fechaAnteriorFormateada }})
    </div>
    <!-- <v-row>
      <v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
        <v-autocomplete
          v-model="filtros.area"
          :items="areas"
          item-value="idArea"
          item-text="nombre"
          label="Área"
          hide-details
          clearable
          @change="changeArea"
        ></v-autocomplete>
      </v-col>  
      <v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
        <v-autocomplete
          v-model="filtros.categoria"
          :items="categorias"
          item-value="idMaquinaCategoria"
          item-text="categoria"
          label="Categoría"
          hide-details
          clearable
          @change="changeCategoria"
        ></v-autocomplete>
      </v-col>

      <v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
        <v-autocomplete
          v-model="filtros.turno"
          :items="turnos"
          item-value="idTurno"
          item-text="nombre"
          label="Turno"
          hide-details
          clearable
          @change="changeTurno"
        ></v-autocomplete>
      </v-col>

      <v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
        <v-autocomplete
          v-model="filtros.causa"
          :items="causas"
          item-value="idParoTipo"
          item-text="nombre"
          label="Causa"
          hide-details
          clearable
          @change="changeCausa"
        ></v-autocomplete>
      </v-col>  
      <v-col cols="4" md="4" sm="4" class="align-self-end">
        <v-autocomplete
					v-model="filtros.subcausa"
					:items="subcausasFiltradas"
					item-value="idSubParoTipo"
					item-text="nombreSubParoTipo"
					label="Subcausa"
					hide-details
					clearable
          @change="changeSubcausa"
				></v-autocomplete>
      </v-col>

      <v-col cols="4" md="4" sm="4" class="align-self-end">
        <MaquinaInsAutocomplete
          v-model="filtros.instancias"
          :items="instanciasFiltradas"
          item-value="idMaquinaIns"
          item-text="nombre"
          label="Máquina"
          clearable
          multiple
          chips
          small-chips
          hide-details
          @change="historial_update_page_action(1)"
        />
      </v-col>
      <v-col cols="4" md="4" sm="4" class="align-self-end">
        <v-autocomplete
          v-model="filtros.maquina"
          :items="maquinasFiltradas"
          item-value="idMaquina"
          :item-text="marcaModelo"
          label="Modelo"
          hide-details
          clearable
          @change="changeMaquina"
        ></v-autocomplete>
      </v-col>
      <v-col cols="4" md="4" sm="4" class="align-self-end">
        <v-autocomplete
					v-model="filtros.gruposm"
					:items="gruposFiltrados"
					item-value="idMaquinaTipo"
					item-text="nombre"
					label="Grupo de Máquinas"
					hide-details
					clearable
          @change="changeGrupoM"
				></v-autocomplete>
      </v-col>

      <v-col v-if="!filtros.turno" cols="4" md="4" sm="4" class="align-self-end">
        <datePicker
            v-model="filtros.inicio"
            :only-date="!!filtros.turno"
            format="YYYY-MM-DD"
            :label="filtros.turno ? 'Fecha' : 'Desde'"
            noHeader
            clearable
            overlay
            maxToday
            buttonNowTranslation="Ahora"
            @input="onInicioChange"
            :disabled="loading"
          />
      </v-col>
      <v-col cols="4" md="4" sm="4" class="align-self-end">
				<datePicker
            v-if="!filtros.turno"
            :key="'fin-'+(filtros.inicio || '')"
            v-model="filtros.fin"
            :minDate="filtros.inicio"
            :only-date="!!filtros.turno"
            format="YYYY-MM-DD"
            label="Hasta"
            noHeader
            clearable
            overlay
            maxToday
            buttonNowTranslation="Ahora"
            @input="historial_update_page_action(1);"
            :disabled="loading"
          />
			</v-col>
    </v-row>
    <download-btn
      color="blue darken-1"
      text 
      @click="descargarReporte"
      label="Descargar Reporte<br>de Uso de Máquinas"
    ></download-btn>
    <download-btn
      v-if="nombreEmpresa === 'Nyx' || nombreEmpresa === 'Glm' || nombreEmpresa === 'TAMTO'"
      color="blue darken-1"
      text 
      @click="descargarReporteParo"
      label="Descargar Reporte<br>de MTTR y MTBF"
    ></download-btn> -->
    <!--<v-row v-if="estadisticas.length > 0 && (nombreEmpresa === 'Nyx' || nombreEmpresa === 'Tamto')">
      <v-col cols="6" md="6" sm="6">
        <apexchart type="pie" width="380" :options="usoTiempoChartOptions" :series="usoTiempoSeries" ref="chartSegundos"></apexchart>
      </v-col>
      <v-col cols="6" md="6" sm="6">
        <apexchart type="pie" width="380" :options="usoCantidadChartOptions" :series="usoCantidadSeries" ref="chartCantidad"></apexchart>
      </v-col>
    </v-row>-->
    <v-row>
       <!-- Mostrar gráficos lado a lado solo para Cazel -->
      <template v-if="nombreEmpresa === 'Cazel'">
        <v-col cols="6">
          <!-- MTTR -->
          <apexchart 
            type="bar" 
            height="580" 
            :options="MTTRchartOptions" 
            :series="MTTRSeries" 
            ref="chartMTTR"
          ></apexchart>
          <v-card elevation="8">
            <v-card-title class="d-flex justify-center align-center text-center">MTTR Promedio</v-card-title>
            <v-card-text class="d-flex justify-center align-center text-center">
              {{ avgTimeOrNA(MTTRSeries[0].data) }}
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <!-- MTBF -->
          <apexchart 
            type="bar" 
            height="580" 
            :options="MTBFchartOptions" 
            :series="MTBFSeries" 
            ref="chartMTBF"
          ></apexchart>
          <v-card elevation="8">
            <v-card-title class="d-flex justify-center align-center text-center">MTBF Promedio</v-card-title>
            <v-card-text class="d-flex justify-center align-center text-center">
              {{ avgTimeOrNA(MTBFSeries[0].data) }}
            </v-card-text>
          </v-card>
        </v-col>
      </template>
    <!-- MTTR -->
    <v-col :cols="nombreEmpresa !== 'NYX' ? 12 : 6" :md="nombreEmpresa !== 'NYX' ? 12 : 6" :sm="nombreEmpresa !== 'NYX' ? 12 : 6">
      <apexchart 
        type="bar" 
        height="580" 
        :options="MTTRchartOptions" 
        :series="MTTRSeries" 
        ref="chartMTTR"
      ></apexchart>
      <v-card elevation="8">
        <v-card-title class="d-flex justify-center align-center text-center">MTTR Promedio</v-card-title>
        <v-card-text class="d-flex justify-center align-center text-center">
          {{ avgTimeOrNA(MTTRSeries[0].data) }}
        </v-card-text>
      </v-card>
    </v-col>

    <!-- MTBF -->
    <v-col :cols="nombreEmpresa !== 'NYX' ? 12 : 6"
          :md="nombreEmpresa !== 'NYX' ? 12 : 6"
          :sm="nombreEmpresa !== 'NYX' ? 12 : 6">

      <!-- TAMTO: título fijo + scroll -->
      <template v-if="nombreEmpresa !== 'NYX'">
        <v-card v-if="loadingMTBF" elevation="0">
          <div class="text-h6 text-center">Cargando MTBF</div>
          <div class="text-center">
            <v-progress-circular :size="50" color="primary" indeterminate />
          </div>
        </v-card>

        <v-card v-else elevation="0" class="mtbf-card">
          <v-card-title class="chart-fixed-title">MTBF por Máquina</v-card-title>
          <div class="x-scroll">
            <div :style="mtbfInnerStyle">
              <apexchart
                type="bar"
                height="520"
                :options="MTBFchartOptionsNoTitle"
                :series="MTBFSeries"
                ref="chartMTBF"
              />
            </div>
          </div>
        </v-card>
      </template>

      <!-- NYX: gráfico normal sin scroll -->
      <template v-else>
        <v-card v-if="loadingMTBF" elevation="0">
          <div class="text-h6 text-center">Cargando MTBF</div>
          <div class="text-center">
            <v-progress-circular :size="50" color="primary" indeterminate />
          </div>
        </v-card>

        <apexchart
          v-else
          type="bar"
          height="580"
          :options="MTBFchartOptions"
          :series="MTBFSeries"
          ref="chartMTBF"
        />
      </template>

      <v-card elevation="8">
        <v-card-title class="d-flex justify-center align-center text-center">
          MTBF Promedio
        </v-card-title>
        <v-card-text class="d-flex justify-center align-center text-center">
            {{ avgTimeOrNA(MTBFSeries[0].data) }}
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
    <br>
    <!-- <v-data-table
      :headers="headers"
      :items="historial"
      :loading="loading"
      loading-text="Cargando... Espere, Por Favor."
      :server-items-length="historial_total"
      :items-per-page="historial_items_per_page"
      :page="historial_actual_page"
      @update:page="historial_update_page_action"
      @update:items-per-page="(ipp) => historial_items_per_page = ipp"
      @update:sort-by="historial_sort_by_action"
      :footer-props="{disableItemsPerPage:true, disablePagination: this.loading }"
      :disable-sort="true"
    >
      <template v-if="nombreEmpresa != 'Nyx'" v-slot:[`item.categoria`]="{ item }">
         {{(item.categoria == null)?"SIN ASIGNAR":item.categoria}}
      </template>
      <template v-if="nombreEmpresa === 'Nyx' || nombreEmpresa === 'Glm' || nombreEmpresa === 'TAMTO'" v-slot:[`item.area`]="{ item }">
         {{(item.area == null)?"SIN ASIGNAR":item.area}}
      </template>
      <template v-if="nombreEmpresa != 'Nyx'" v-slot:[`item.marcaModelo`]="{ item }">
         {{(item.marca == null)?"SIN ASIGNAR":item.marca}}
      </template>
      <template v-if="nombreEmpresa === 'Nyx' || nombreEmpresa === 'Glm' || nombreEmpresa === 'TAMTO'" v-slot:[`item.paroTipo`]="{ item }">
         {{(item.causa == null)?"SIN ASIGNAR":item.causa}}
      </template>
       <template v-slot:[`item.subcausa`]="{ item }">
         {{ (item.subcausa == null || item.subcausa == 'S/D') ? 'SIN ASIGNAR' : item.subcausa }}
      </template>
    </v-data-table> -->
  </v-col>
</template>

<script>
import axios from "axios";
import {mapState, mapMutations} from "vuex";
import moment from "moment";
import MaquinaInsAutocomplete from "../../Mantenimiento/MaquinaInsAutocomplete.vue";

export default {

  data: () => ({
    historial:[],
    categorias:[],
    maquinas:[],
    instancias:[],
    estadisticas:[],
    mtbfPxPerCat: 72, // px por categoría (ajústalo si quieres más/menos densidad)
    MTBFchartOptionsNoTitle: {           // <— DEBE existir en data
      chart: { type: 'bar', toolbar: { show: true } },
      plotOptions: { bar: { horizontal: false, columnWidth: '45%' } },
      xaxis: { categories: [], labels: { rotate: -45, trim: true, hideOverlappingLabels: true, style: { fontSize: '11px' } } },
      yaxis: { labels: { formatter: (v) => '' + v } }, // lo sobrescribimos en redibujarMTBF
      dataLabels: { enabled: false },
      tooltip: { y: { formatter: (v) => '' + v } },
      legend: { show: false },
    },
    mttr:[],
    mtbf:[],
    areas: [],
    turnos: [],
    causas: [],
    subcausas: [],
    gruposMaquinas: [],
    loadingMTBF: false,
    filtros:{
      categoria: null,
      maquina:null,
      instancias:[],
      inicio:null,
      fin:null,
      area:null,
      turno: null,
      causa: null,
      subcausa: null,
      gruposm: null,
    },
    loading:false,
    historial_total:0,
    historial_items_per_page:10,
    historial_actual_page:1,
    
    defaultTiempoChartOptions: {
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: [],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      yaxis: {
        labels: {
          formatter: function (value) {
            var tiempo = Math.floor(value);
            var horas = Math.trunc(tiempo/3600);
            tiempo -= horas * 3600;
            if(horas <10) horas = "0"+horas;
            var minutos =  Math.trunc(tiempo / 60);
            tiempo -= minutos * 60;
            if(minutos <10) minutos = "0"+minutos;
            if(tiempo <10) tiempo = "0"+tiempo;
            return horas+":"+minutos+":"+tiempo;
          }
        }
      }
    },
    usoTiempoChartOptions:{
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: [],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
    usoTiempoSeries:[],
    usoCantidadChartOptions:{
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: [],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
    usoCantidadSeries:[],
    usoCantidadUnidades:[],
    defaultCantidadChartOptions: {
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: [],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      yaxis: {
        labels: {
          formatter:(value,opts) =>{
            return value;
          },
        }
      }
    },
    MTBFSeries: [{
      data: [],
      name: "MTBF"
    }],
    MTBFchartOptions: {
      chart: {
        height: 480,
        type: 'bar',
        toolbar: {
          show: false
        }
      },
      title: {
        text: 'MTBF por Máquina',
        align: 'center',
        margin: 20,
        offsetY: 10,
        style: {
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#333'
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          let tiempo = Math.floor(val);
          let horas = Math.trunc(tiempo / 3600);
          tiempo -= horas * 3600;
          if (horas < 10) horas = "0" + horas;
          let minutos = Math.trunc(tiempo / 60);
          tiempo -= minutos * 60;
          if (minutos < 10) minutos = "0" + minutos;
          if (tiempo < 10) tiempo = "0" + tiempo;
          return horas + ":" + minutos + ":" + tiempo;
        },
        offsetY: -20,
        style: {
          fontSize: '24px',
          fontWeight: 'bold',
          colors: ['#000']
        }
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            var tiempo = Math.floor(value);
            var horas = Math.trunc(tiempo/3600);
            tiempo -= horas * 3600;
            if(horas <10) horas = "0"+horas;
            var minutos =  Math.trunc(tiempo / 60);
            tiempo -= minutos * 60;
            if(minutos <10) minutos = "0"+minutos;
            if(tiempo <10) tiempo = "0"+tiempo;
            return horas+":"+minutos+":"+tiempo;
          }
        }
      }
    },
    defaultMTBFChartOptions: {
      chart: {
        height: 480,
        type: 'bar',
        toolbar: {
          show: false
        }
      },
      title: {
        text: 'MTBF por Máquina',
        align: 'center',
        margin: 20,
        offsetY: 0,
        style: {
          fontSize: '32px',
          color: '#000000',
          fontFamily: 'Arial'
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          let tiempo = Math.floor(val);
          let horas = Math.trunc(tiempo / 3600);
          tiempo -= horas * 3600;
          if (horas < 10) horas = "0" + horas;
          let minutos = Math.trunc(tiempo / 60);
          tiempo -= minutos * 60;
          if (minutos < 10) minutos = "0" + minutos;
          if (tiempo < 10) tiempo = "0" + tiempo;
          return horas + ":" + minutos + ":" + tiempo;
        },
        offsetY: -20,
        style: {
          fontSize: '24px',
          fontWeight: 'bold',
          colors: ['#000']
        }
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            var tiempo = Math.floor(value);
            var horas = Math.trunc(tiempo/3600);
            tiempo -= horas * 3600;
            if(horas <10) horas = "0"+horas;
            var minutos =  Math.trunc(tiempo / 60);
            tiempo -= minutos * 60;
            if(minutos <10) minutos = "0"+minutos;
            if(tiempo <10) tiempo = "0"+tiempo;
            return horas+":"+minutos+":"+tiempo;
          }
        }
      }
    },
    MTTRSeries: [{
      data: [],
      name: "MTTR"
    }],
    MTTRChartOptions: {
      chart: {
        height: 380,
        type: 'bar',
        toolbar: {
          show: false
        }
      },
      title: {
        text: 'MTTR por Máquina',
        align: 'center',
        margin: 30,  // un poco más de espacio con las barras
        offsetY: 10, // bajamos un poco el título
        style: {
          fontSize: '40px',  // <<<<< AUMENTADO
          fontWeight: '900', // <<<<< MÁS GRUESO
          color: '#000000',
          fontFamily: 'Arial'
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          let tiempo = Math.floor(val);
          let horas = Math.trunc(tiempo / 3600);
          tiempo -= horas * 3600;
          if (horas < 10) horas = "0" + horas;
          let minutos = Math.trunc(tiempo / 60);
          tiempo -= minutos * 60;
          if (minutos < 10) minutos = "0" + minutos;
          if (tiempo < 10) tiempo = "0" + tiempo;
          return horas + ":" + minutos + ":" + tiempo;
        },
        offsetY: -20,
        style: {
          fontSize: '24px',
          fontWeight: 'bold',
          colors: ['#000']
        }
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            var tiempo = Math.floor(value);
            var horas = Math.trunc(tiempo/3600);
            tiempo -= horas * 3600;
            if(horas <10) horas = "0"+horas;
            var minutos =  Math.trunc(tiempo / 60);
            tiempo -= minutos * 60;
            if(minutos <10) minutos = "0"+minutos;
            if(tiempo <10) tiempo = "0"+tiempo;
            return horas+":"+minutos+":"+tiempo;
          }
        }
      }
    },
    defaultMTTRChartOptions: {
      chart: {
        height: 380,
        type: 'bar',
        toolbar: {
          show: false
        }
      },
      title: {
        text: 'MTTR por Máquina',
        align: 'center',
        margin: 20,
        offsetY: 0,
        margin: 30,  // un poco más de espacio con las barras
        offsetY: 10, // bajamos un poco el título
        style: {
          fontSize: '40px',  // <<<<< AUMENTADO
          fontWeight: '900', // <<<<< MÁS GRUESO
          fontWeight: 'bold',
          color: '#000000',
          fontFamily: 'Arial'
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          let tiempo = Math.floor(val);
          let horas = Math.trunc(tiempo / 3600);
          tiempo -= horas * 3600;
          if (horas < 10) horas = "0" + horas;
          let minutos = Math.trunc(tiempo / 60);
          tiempo -= minutos * 60;
          if (minutos < 10) minutos = "0" + minutos;
          if (tiempo < 10) tiempo = "0" + tiempo;
          return horas + ":" + minutos + ":" + tiempo;
        },
        offsetY: -20,
        style: {
          fontSize: '24px',
          fontWeight: 'bold',
          colors: ['#000']
        }
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: '12px'
          }
        }
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            var tiempo = Math.floor(value);
            var horas = Math.trunc(tiempo/3600);
            tiempo -= horas * 3600;
            if(horas <10) horas = "0"+horas;
            var minutos =  Math.trunc(tiempo / 60);
            tiempo -= minutos * 60;
            if(minutos <10) minutos = "0"+minutos;
            if(tiempo <10) tiempo = "0"+tiempo;
            return horas+":"+minutos+":"+tiempo;
          }
        }
      }
    }
  }),
  components: { MaquinaInsAutocomplete },
  created(){
    const rango = this.fechaPorDefecto();
		this.filtros.inicio = rango.inicio;
		this.filtros.fin = rango.fin;
    this.initialize();
  },
  computed:{
    fechaAnteriorFormateada() {
			const fechaStr = this.filtros.inicio;
			if (!fechaStr) return '';
			const [datePart] = fechaStr.split(' ');
			const [yyyy, mm, dd] = datePart.split('-');
			return `${dd}-${mm}-${yyyy}`;
		},
    ...mapState({
      nombreEmpresa: "nombreEmpresa",
    }),
    mtbfPixelWidth () {
      if (this.nombreEmpresa === 'NYX') return 1000;
      const n = (this.mtbf && this.mtbf.length) ? this.mtbf.length : 1;
      return Math.max(1000, n * this.mtbfPxPerCat);
    },
    mtbfColumnWidth () {
      const n = (this.mtbf && this.mtbf.length) ? this.mtbf.length : 0;
      if (n <= 1) return '45%';   // 1 máquina → casi todo el ancho
      if (n <= 3) return '70%';   // 2–3 máquinas → ancho cómodo
      return '45%';               // 4+ → normal
    },
    mtbfInnerStyle () {
      const n = (this.mtbf && this.mtbf.length) ? this.mtbf.length : 0;
      const needed = Math.max(1000, n * this.mtbfPxPerCat); // lo que “pedimos” cuando haya muchas
      return {
        width: '100%',        // ocupa todo el card si cabe
        minWidth: needed + 'px' // y solo crece (con scroll) si hace falta
      };
    },
    gruposFiltrados () {
      // 1) por instancias (multi)
      if (Array.isArray(this.filtros.instancias) && this.filtros.instancias.length) {
        const instSel = new Set(this.filtros.instancias);
        const tipos = new Set(
          this.instancias
            .filter(i => instSel.has(i.idMaquinaIns))
            .map(i => i.idMaquinaTipo)
            .filter(id => this.$utils.isValid(id))
        );
        return this.gruposMaquinas.filter(g => tipos.has(g.idMaquinaTipo));
      }
      // 2) por máquina (todas sus instancias)
      if (this.$utils.isValid(this.filtros.maquina)) {
        const tipos = new Set(
          this.instancias
            .filter(i => i.idMaquina === this.filtros.maquina)
            .map(i => i.idMaquinaTipo)
            .filter(id => this.$utils.isValid(id))
        );
        return this.gruposMaquinas.filter(g => tipos.has(g.idMaquinaTipo));
      }

      // 3) sin filtro → todos
      return this.gruposMaquinas;
    },
    instanciasFiltradas () {
      let xs = this.instancias;
      if (this.$utils.isValid(this.filtros.maquina)) {
        xs = xs.filter(i => i.idMaquina === this.filtros.maquina);
      }
      if (this.$utils.isValid(this.filtros.gruposm)) {
        xs = xs.filter(i => i.idMaquinaTipo === this.filtros.gruposm);
      }
      return xs;
    },
    subcausasFiltradas() {
      return this.filtros.causa
        ? this.subcausas.filter(s => s.idParoTipo === this.filtros.causa)
        : [];
    },
    headers() {
      const cols = [
        {
          text: ['Nyx','Glm','TAMTO'].includes(this.nombreEmpresa) ? 'Área' : 'Categoría',
          align: 'center',
          sort: false,
          value: ['Nyx','Glm','TAMTO'].includes(this.nombreEmpresa) ? 'area' : 'categoria',
          width: '8.33%',
        },
        {
          text: ['Nyx','Glm','TAMTO'].includes(this.nombreEmpresa) ? 'Causa' : 'Máquina',
          align: 'center',
          sort: false,
          value: ['Nyx','Glm','TAMTO'].includes(this.nombreEmpresa) ? 'paroTipo' : 'marcaModelo',
          width: '8.33%',
        },
        {
          text: 'Subcausa',
          align: 'center',
          sort: false,
          value: 'subcausa',
          width: '8.33%',
          //onlyForTamto: true,
        },
        {
          text: "Máquina Instancia",
          align: 'center',
          sort: false,
          value: 'nombreMaquinaIns',
          width: '8.33%',
        },
        {
          text: "Inicio",
          align: 'center',
          sort: false,
          value: 'inicio',
          width: '8.33%',
        },
        {
          text: "Fin",
          align: 'center',
          sort: false,
          value: 'fin',
          width: '8.33%',
        },
        {
          text: "Duración",
          align: 'center',
          sort: false,
          value: 'duracion',
          width: '8.33%',
        },
        {
          text: "Realizó",
          align: 'center',
          sort: false,
          value: 'realizo',
          width: '8.33%',
        }
      ];
      // cuando no es TAMTO
      return cols
    },
    
    /*instanciasFiltradas(){
      if(this.$utils.isValid(this.filtros.maquina)){
        return this.instancias.filter(instancias => {
          return instancias.idMaquina == this.filtros.maquina;
        })
      }
      else return this.instancias;
    },*/
    maquinasFiltradas(){
      if(this.$utils.isValid(this.filtros.categoria)){
        if(this.filtros.categoria == 0){
          return this.instancias.filter(instancias => {
            return instancias.idMaquinaCategoria == null;
          })
        }
        else{
          return this.instancias.filter(instancias => {
            return instancias.idMaquinaCategoria == this.filtros.categoria;
          })
        }
      }
      else return this.instancias;
    },
    historial_fetch_url(){
      return `/Mantenimientos/${(this.nombreEmpresa === 'Nyx' || this.nombreEmpresa === 'Glm' || this.nombreEmpresa === 'TAMTO') ? 'ReporteMaquinasParo' : 'ReporteMaquinasUso' }?paginar=true&page=${this.historial_actual_page}&size=${this.historial_items_per_page}` + this.historial_filtros_url;
    },
    historial_estadisticas_fetch_url(){
      var filtros = this.historial_filtros_url;
      if(filtros.length > 0 && filtros[0] == '&'){
        filtros = filtros.substr(1);
      }
      return `/Mantenimientos/ReporteTiempoMaquina?`+filtros;
    },
    mttr_fetch_url(){
      var filtros = this.historial_filtros_url;
      if(filtros.length > 0 && filtros[0] == '&'){
        filtros = filtros.substr(1);
      }
      return `/DisponibilidadEquipo/MTTR?`+filtros;
    },
    mtbf_fetch_url(){
      var filtros = this.historial_filtros_url;
      if(filtros.length > 0 && filtros[0] == '&'){
        filtros = filtros.substr(1);
      }
      return `/DisponibilidadEquipo/MTBF?`+filtros;
    },
    historial_filtros_url() {
      var url = "";

      if(this.$utils.isValid( this.filtros.categoria )){
        url += '&IdMaquinaCategoria='+this.filtros.categoria;
      }

      if(this.$utils.isValid(this.filtros.maquina)){
        url += '&idMaquina='+this.filtros.maquina;  
      }

      if (Array.isArray(this.filtros.instancias) && this.filtros.instancias.length){
        this.filtros.instancias.forEach(id => { url += '&idMaquinaIns=' + id; });
      }

      if(this.$utils.isValid(this.filtros.inicio)){
        url += '&inicio='+this.filtros.inicio;  
      }

      if (this.$utils.isValid(this.filtros.fin)) {
        // solo mandar fin si no hay inicio o fin >= inicio
        if (!this.filtros.inicio || this.filtros.fin >= this.filtros.inicio) {
          url += '&fin=' + this.filtros.fin;
        } else {
          // lo descartamos silenciosamente
          this.filtros.fin = null;
        }
      }

      if(this.$utils.isValid(this.filtros.area)){
        url += '&idArea='+this.filtros.area;
      }
      if(this.$utils.isValid(this.filtros.turno)){
        url += '&idTurno=' + this.filtros.turno;
      }

      if(this.$utils.isValid(this.filtros.causa)){
        url += '&idParoTipo='+this.filtros.causa;
      }

      if(this.$utils.isValid(this.filtros.subcausa)){
        url += '&idSubParoTipo='+this.filtros.subcausa;
      }

      if(this.$utils.isValid(this.filtros.gruposm)){
        url += '&idMaquinaTipo='+this.filtros.gruposm;
      }

      return url;
    },
  },
  watch: {
    // si cambian instancias manualmente, también sincroniza
    'filtros.instancias': {
      handler () { this._syncGrupoConFiltro(); },
      deep: true,
    },
    'filtros.inicio'(nuevo) {
      // si inicio se limpia, limpia fin también
      if (!nuevo) {
        this.filtros.fin = null;
        return;
      }
      // si fin existe y quedó antes que inicio, límpialo
      if (this.filtros.fin && this.filtros.fin < nuevo) {
        this.filtros.fin = null;
      }
    }
  },
  methods:{
    fmtHMS (s) {
      s = Math.floor(s || 0);
      const h = Math.floor(s/3600), m = Math.floor((s%3600)/60), sec = s%60;
      const pad = n => (n<10?'0':'')+n;
      return `${pad(h)}:${pad(m)}:${pad(sec)}`;
    },
    onInicioChange(v) {
      // normaliza
      this.filtros.inicio = v || null;
      if (this.filtros.fin && this.filtros.fin < this.filtros.inicio) {
        this.filtros.fin = null;
      }
      this.historial_update_page_action(1);
    },
    avgTimeOrNA (arr) {
      const nums = Array.isArray(arr)
        ? arr.map(Number).filter(n => Number.isFinite(n) && n >= 0)
        : [];
      if (!nums.length) return 'Sin Información';
      const prom = nums.reduce((a,b)=>a+b,0) / nums.length;
      return this.formatTime(prom);
    },
    redibujarMTBF () {
      const base = Array.isArray(this.mtbf) ? this.mtbf : [];
      const cats = base.map(x => x.codigo);
      const data = base.map(x => x.segundos);

      this.MTBFchartOptionsNoTitle = {
        ...this.MTBFchartOptionsNoTitle,
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: this.mtbfColumnWidth,
            dataLabels: { position: 'top' }
          }
        },
        xaxis: {
          categories: cats,
          labels: { rotate: -45, trim: true, hideOverlappingLabels: true, style: { fontSize: '12px' } },
        },
        yaxis: { labels: { formatter: (v) => this.fmtHMS(v) } },
        tooltip: { y: { formatter: (v) => this.fmtHMS(v) } },

        dataLabels: {
          enabled: true,
          formatter: (v) => this.fmtHMS(v),
          offsetY: -18,
          style: { fontSize: '12px', fontWeight: 'bold', colors: ['#000'] }
        }
      };

      this.MTBFSeries = [{ name: 'MTBF', data }];

      // (opcional) forzar redibujo si usas vue-apexcharts < v1.7
      this.$nextTick(() => {
        if (this.$refs.chartMTBF?.updateOptions) {
          this.$refs.chartMTBF.updateOptions(this.MTBFchartOptionsNoTitle, true, true);
        }
      });
    },
    fechaPorDefecto() {
      const hoy = new Date();
        hoy.setDate(hoy.getDate() - 1);

        const yyyy = hoy.getFullYear();
        const mm   = String(hoy.getMonth() + 1).padStart(2, '0');
        const dd   = String(hoy.getDate()).padStart(2, '0');

        const fecha = `${yyyy}-${mm}-${dd}`;
        return {
          inicio: fecha,
          fin: fecha
      };
    },
    average: arr => arr.reduce((a, b) => a + b, 0) / arr.length,
    formatTime: s => {
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const sec = Math.round(s % 60);

      let parts = [];
      if (d > 0) parts.push(`${d} día${d !== 1 ? 's' : ''}`);
      if (h > 0) parts.push(`${h} hora${h !== 1 ? 's' : ''}`);
      if (m > 0) parts.push(`${m} minuto${m !== 1 ? 's' : ''}`);
      if (sec > 0 || parts.length === 0) parts.push(`${sec} segundo${sec !== 1 ? 's' : ''}`);

      return parts.join(', ');
    },
    marcaModelo: item => item.marca +' - '+item.modelo,
    initialize(){
      this.getMaquinas();
      this.getInstancias();
      this.getAreas();
      this.getCausas();
      this.getTipoSubParos();
      this.getGruposMaquinas();
      this.getTurnos();
      this.historial_update_page_action(1);
    },
    getMaquinas(){
      axios
      .get("/Maquinas")
      .then(response =>  {
        this.maquinas = response.data.filter(function(el) {
          return (el.esMaquina == true);
        });
        this.categorias = this.maquinas.map( elemento => ({
          idMaquinaCategoria: (elemento.idMaquinaCategoria == null)?0:elemento.idMaquinaCategoria,
          categoria: elemento.categoria
        }));
      })
      .catch(error => {
        console.log(error);
      });
    },
    getInstancias(){
      axios
      .get("/MaquinaInstancias")
      .then(response =>  {
        this.instancias = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    },
    changeCategoria(){
      this.filtros.maquina = null;
      this.filtros.instancias = [];
      this.historial_update_page_action(1);
    },
    /*changeTurno(){
      this.filtros.instancias = [];
      this.historial_update_page_action(1);
    },*/
    changeMaquina () {
      this.filtros.instancias = [];
      this._syncGrupoConFiltro();
      this.historial_update_page_action(1);
    },
    changeArea(){ this.filtros.instancias = []; this._syncGrupoConFiltro(); this.historial_update_page_action(1); },
    changeCausa(){ this.filtros.instancias = []; this._syncGrupoConFiltro(); this.historial_update_page_action(1); },
    changeSubcausa(){ this.filtros.instancias = []; this._syncGrupoConFiltro(); this.historial_update_page_action(1); },
    changeTurno(){
      this.filtros.instancias = [];
      if (this.filtros.turno) this.filtros.fin = null; // ← importante
      this._syncGrupoConFiltro();
      this.historial_update_page_action(1);
    },
    changeGrupoM(){ this.filtros.instancias = []; this.historial_update_page_action(1); },
    /*changeArea(){
      this.filtros.instancias = [];
      this.historial_update_page_action(1);
    },
    changeCausa(){
      this.filtros.instancias = [];
      this.historial_update_page_action(1);
    },
    changeSubcausa(){
      this.filtros.instancias = [];
      this.historial_update_page_action(1);
    },
    changeGrupoM(){
      this.filtros.instancias = [];
      this.historial_update_page_action(1);
    },*/
    _syncGrupoConFiltro () {
      const validIds = new Set(this.gruposFiltrados.map(g => g.idMaquinaTipo));
      if (this.filtros.gruposm && !validIds.has(this.filtros.gruposm)) {
        this.filtros.gruposm = null;
      }
      // Autoselect si solo hay 1
      if (!this.filtros.gruposm && validIds.size === 1) {
        this.filtros.gruposm = [...validIds][0];
      }
    },
    async historial_update_page_action(page) {
      this.historial_actual_page = page;
      this.loading = true;
      try {
        let response = await this.getHistorial();
        this.historial = response.data.result;
        //console.log(response);
        this.historial_total = response.data.total;
        this.loading = false;
      } catch (exception) {
        console.log(exception);
      }
        
      this.getEstadisticas()
      .then(response => {
        this.estadisticas = response.data;
        var usoTiempoChartOptions = Object.assign({},this.defaultTiempoChartOptions);
        usoTiempoChartOptions.labels = this.estadisticas.map(e => {
          //return e.marca + " - " + e.modelo + " [" +e.codigo +"]"
          return e.codigo;
        });
        this.usoTiempoChartOptions = usoTiempoChartOptions;
        this.usoTiempoSeries = this.estadisticas.map(e => e.segundos);
        setTimeout(() => {
          this.$refs.chartSegundos.refresh();
        },350);
        var usoCantidadChartOptions = Object.assign({},this.defaultCantidadChartOptions);
        usoCantidadChartOptions.labels = this.estadisticas.map(e => {
          //return e.marca + " - " + e.modelo + " [" +e.codigo +"]"
          return e.codigo;
        });
        this.usoCantidadChartOptions = usoCantidadChartOptions;
        this.usoCantidadSeries = this.estadisticas.map(e => e.cantidad);
        this.usoCantidadUnidades = this.estadisticas.map(e => e.unidad);
        this.usoCantidadChartOptions.yaxis.labels.formatter = (value,opts) => {
          return value.toFixed(2) +" "+ this.usoCantidadUnidades[opts.seriesIndex]
        }
        setTimeout(() => {
          this.$refs.chartCantidad.refresh();
        },350);
      })
      .catch(error => {
        console.log(error);
      });
      
      this.getMTTR()
      .then(response => {
          this.mttr = response.data.filter(x => !(x.idMaquinaIns === 0 && x.codigo === "S/M") && x.mttr > 0);

          var MTTRChartOptions = Object.assign({}, this.defaultMTTRChartOptions);
          MTTRChartOptions.xaxis.categories = this.mttr.map(x => x.codigo);

          // Asegúrate de tomar el valor del MTTR (en minutos) y no de 'segundos'
          var MTTRSeries = [{
              data: this.mttr.map(x => x.mttr), // usa "mttr" que es el valor en minutos
              name: "MTTR"
          }];

          this.MTTRchartOptions = MTTRChartOptions;
          this.MTTRSeries = MTTRSeries;

          setTimeout(() => {
            //this.$refs.chartMTTR.refresh();
          }, 350);
      })
      .catch(error => {
        console.log(error);
      });
    
      this.loadingMTBF = true;
      this.getMTBF()
      .then(response => {
        this.mtbf = response.data.filter(x => !(x.idMaquinaIns === 0 && x.codigo === 'S/M'));

        if (this.nombreEmpresa !== 'NYX') {
          // Variante TAMTO (scroll + sin título dentro del chart)
          this.redibujarMTBF(); // arma MTBFchartOptionsNoTitle + MTBFSeries
        } else {
          // Variante normal
          const opts = Object.assign({}, this.defaultMTBFChartOptions);
          opts.xaxis = { ...(opts.xaxis||{}), categories: this.mtbf.map(x => x.codigo) };
          opts.yaxis = { labels: { formatter: (v) => this.fmtHMS(v) } };
          opts.dataLabels = {
            enabled: true,
            formatter: (v) => this.fmtHMS(v),
            offsetY: -15,
            style: { fontSize: '12px', fontWeight: 'bold', colors: ['#000'] }
          };
          opts.plotOptions = { bar: { ...(opts.plotOptions?.bar||{}), columnWidth: this.mtbfColumnWidth, dataLabels: { position: 'top' } } };
          this.MTBFchartOptions = opts;
          this.MTBFSeries = [{ name: 'MTBF', data: this.mtbf.map(x => x.segundos) }];
        }

        this.loadingMTBF = false;
      })
      .catch(err => { console.log(err); this.loadingMTBF = false; });
    },
    getHistorial() {
      //* Realizamos peticion HTTP
      return new Promise((resolve, reject) => {
        axios
          .get(this.historial_fetch_url)
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    getEstadisticas() {
      //* Realizamos peticion HTTP
      return new Promise((resolve, reject) => {
        axios
          .get(this.historial_estadisticas_fetch_url)
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    getMTTR() {
      //* Realizamos peticion HTTP
      return new Promise((resolve, reject) => {
        axios
          .get(this.mttr_fetch_url)
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    getMTBF() {
      //* Realizamos peticion HTTP
      return new Promise((resolve, reject) => {
        axios
          .get(this.mtbf_fetch_url)
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    historial_sort_by_action($sort) {
    },
    descargarReporte() {
			var datetime = moment().format("YYYYMMDDHHmmss");
			var url = this.historial_filtros_url;
			if (url.length > 0 && url[0] == "&") url = "?" + url.substring(1);
			this.$utils.axios.downloadFile(
				"/Mantenimientos/XLSReporteMaquinasUso" + url,
				"GET",
				"historial-uso-maquinas-" + datetime + ".xlsx",
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
			);
		},
    descargarReporteParo() {
      var datetime = moment().format("YYYYMMDDHHmmss");
      var url = this.historial_filtros_url;
      if (url.length > 0 && url[0] == "&") url = "?" + url.substring(1);
        this.$utils.axios.downloadFile("/Mantenimientos/XLSReporteMaquinasParoUso" + url,
          "GET",
          "historial-paro-maquinas-" + datetime + ".xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
    },
    getAreas() {
      axios
        .get("Areas")
        .then(response => {
          this.areas = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getTurnos() {
      axios
        .get("Turnos")
        .then(response => {
          this.turnos = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCausas() {
      axios
        .get("/ParoTipos/ParoTipo")
        .then(response => {
          this.causas = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getTipoSubParos() {
			axios
				.get("/SubParoTipos")
				.then((response) => {
					this.subcausas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
    getGruposMaquinas() {
			axios
				.get("/MaquinaTipos")
				.then((response) => {
					this.gruposMaquinas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
  }
}
</script>
<style>
.apexcharts-title-text {
  font-size: 32px !important;
  fill: #000000 !important;
  font-family: Arial, sans-serif !important;
}
.mtbf-card .chart-fixed-title {
  text-align: center;
  justify-content: center;
  font-size: 32px;
  color: #333;
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Scroll horizontal solo en la zona del chart */
.mtbf-card .x-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}

.mtbf-card .x-scroll::-webkit-scrollbar { height: 10px; }
.mtbf-card .x-scroll::-webkit-scrollbar-thumb {
  background: #c7c7c7;
  border-radius: 6px;
}
</style>